module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/apple-touch-icon-57x57aa697b407ada7b1e22c3050301cbb626.png";